var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClearAlarms(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84424,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#12B76A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5.84424,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.5002 29.1775V33.8442M33.5002 38.5108H33.5118M45.1668 33.8442C45.1668 40.2875 39.9435 45.5108 33.5002 45.5108C27.0568 45.5108 21.8335 40.2875 21.8335 33.8442C21.8335 27.4008 27.0568 22.1775 33.5002 22.1775C39.9435 22.1775 45.1668 27.4008 45.1668 33.8442Z",
    stroke: "#B8C5CC",
    strokeWidth: 1.67,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearAlarms);
export default __webpack_public_path__ + "static/media/clear-alarms.91d6ee2a98949990aaeb2f0f70d75ba9.svg";
export { ForwardRef as ReactComponent };